import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaCircleInfo } from "react-icons/fa6";
import FloatingLabelDropdown from "../../Common/FloatingLabelDropdown";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FiPlusCircle } from "react-icons/fi";
import { useEffect, useState } from "react";
import { GetAssets, RemoveAssets, GetAssetTypeList } from "../../api/get";
import Modal from "react-responsive-modal";
import { AddAssets, EditAssets } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { FaAngleLeft } from "react-icons/fa6";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { handleApiError } from "../../Common/Helper";
const AssetsComp = () => {
  const [assets, setAssets] = useState({});
  const [openModal, setOpenModal] = useState();
  const [contentLoder, setContentLoader] = useState(true);
  const [assetTypeList, setAssetsTypeList] = useState({});
  const [refresh, setRefresh] = useState(false); // Track changes
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([GetAssets(), GetAssetTypeList()])
      .then(([getAssets, getAssetType]) => {
        if (
          getAssets.success &&
          getAssetType.success &&
          getAssets.status_code === "200" &&
          getAssetType.status_code === "200"
        ) {
          setAssets(getAssets?.data); // Set YourselfData with the fetched details
          setAssetsTypeList(
            getAssetType.data.map((item) => ({
              value: item.asset_type_id,
              label: item.name,
            }))
          );
          setContentLoader(false);
        } else if (!getAssets.success) {
          handleApiError(getAssets, navigate); // Use helper function
        } else if (!getAssetType.success) {
          handleApiError(getAssetType, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, [refresh]);
  // console.log("assets =>",assets );

  const handleRemove = (assets_id) => {
    RemoveAssets(assets_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          console.log(res);
          toast.success("Asset Removed Succesfully");
          setOpenModal(false);
          setRefresh((prev) => !prev);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleEditAsset = (asset) => {
    setOpenModal(true);
    console.log("asset edit ", asset);
    formikEditAsset.setValues({
      asset_type_id: asset.asset_type_id,
      asset_value: asset.asset_value,
      asset_id: asset.asset_id,
    });
  };

  const validationSchema = Yup.object({
    asset_type_id: Yup.string().required("Required field"), // Ensure selection is made
    asset_value: Yup.string().required("Required field"), // Field is required
  });

  const formik = useFormik({
    initialValues: {
      asset_type_id: "", // Default empty or prefilled value
      asset_value: "", // Default empty or prefilled value
    },
    validationSchema, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      console.log("Form submitted with values: ", values);
      AddAssets(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Asset Added Successfully");
            resetForm();
            setRefresh((prev) => !prev);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });

  const formikEditAsset = useFormik({
    initialValues: {
      asset_type_id: "", // Default empty or prefilled value
      asset_value: "", // Default empty or prefilled value
    },
    validationSchema, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      console.log("Edit Asset submitted with values: ", values);
      EditAssets(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Asset Updated Successfully");
            setOpenModal(false);
            resetForm();
            setRefresh((prev) => !prev);
          } else {
           handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div>
            <div className="container">
              <div className="grid grid-cols-2 max-lg:grid-cols-1">
                <div className="mt-[20px] ">
                  <div>
                    <h4 className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] mb-5">
                      Your assets(optional)
                    </h4>
                    <div className="bg-lavender flex gap-3  px-5 py-5">
                      <div className="mt-1">
                        <FaCircleInfo />
                      </div>
                      <div>
                        Adding information about your assets can help your
                        executors settle your estate quickly. Here you can
                        include bank accounts, stocks and shares or any pension
                        or life insurance plans you might have.
                      </div>
                    </div>
                  </div>

                  {assets && assets.length > 0
                    ? assets.map((asset, index) => {
                        return (
                          <div key={asset.asset_id || index} className="my-5">
                            <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4">
                              <div className="flex items-center justify-between mt-[16px]">
                                <div className="flex items-center gap-5">
                                  <div>
                                    <img
                                      src="/assets/images/icon-mascot.png"
                                      alt="mascot"
                                    />
                                  </div>
                                  <div>
                                    <h4 className="text-[16px] text-black font-bold">
                                      {asset?.asset_value}
                                    </h4>
                                    <p className="text-[14px]">
                                      {asset?.asset_type_name}
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <button
                                    onClick={() => handleEditAsset(asset)}
                                    className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                                  >
                                    Edit
                                  </button>
                                </div>
                                <Modal
                                  open={openModal}
                                  onClose={() => setOpenModal(false)}
                                  classNames={{
                                    modal:
                                      "rounded-[5px] p-5 w-[95%] sm:w-[80%] md:w-[60%] lg:w-[40%] !m-0", // Adjusting modal width
                                  }}
                                  center
                                >
                                  <form onSubmit={formikEditAsset.handleSubmit}>
                                    <div>
                                      <h2 className="font-bold text-[24px]">
                                        Edit asset
                                      </h2>
                                      <div className="flex items-center gap-5 mt-[30px]">
                                        <div className="w-[400px]">
                                          <FloatingLabelDropdown
                                            label="Type Of Assets"
                                            options={assetTypeList}
                                            value={
                                              formikEditAsset.values
                                                .asset_type_id
                                            }
                                            onChange={
                                              formikEditAsset.handleChange
                                            }
                                            name="asset_type_id"
                                            error={
                                              formikEditAsset.touched
                                                .asset_type_id &&
                                              formikEditAsset.errors
                                                .asset_type_id
                                            }
                                          />
                                        </div>
                                        <div className="w-[400px]">
                                          <FloatingLabelInput
                                            label="Company Name"
                                            type="text"
                                            id="asset_value"
                                            name="asset_value"
                                            value={
                                              formikEditAsset.values.asset_value
                                            }
                                            onChange={
                                              formikEditAsset.handleChange
                                            }
                                            onBlur={formikEditAsset.handleBlur}
                                            error={
                                              formikEditAsset.touched
                                                .asset_value &&
                                              formikEditAsset.errors.asset_value
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-wrap justify-between items-center gap-4 mt-5">
                                      {/* Update Assets Button */}
                                      <div className="w-full sm:w-[48%]">
                                        <button
                                          type="submit"
                                          className="w-full bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2 text-sm sm:text-base hover:bg-primary-dark transition-all"
                                        >
                                          Update Assets
                                        </button>
                                      </div>

                                      {/* Remove Assets Button */}
                                      <div className="w-full sm:w-[48%]">
                                        <button
                                          type="button"
                                          onClick={() => {
                                            handleRemove(
                                              formikEditAsset.values.asset_id
                                            );
                                          }}
                                          className="w-full border border-[#240642] hover:bg-primary hover:text-white transition-all ease-out px-5 py-3 text-black font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2 text-sm sm:text-base"
                                        >
                                          Remove Assets
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </Modal>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : " "}

                  <form onSubmit={formik.handleSubmit}>
                    <div className="">
                      <h4 className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] mt-5">
                        Add your asset
                      </h4>
                    </div>
                    <div className="grid grid-cols-2 mt-[20px] gap-5">
                      <div>
                        <FloatingLabelDropdown
                          label="Type Of Assets"
                          options={assetTypeList}
                          value={formik.values.asset_type_id}
                          onChange={formik.handleChange}
                          name="asset_type_id"
                          error={
                            formik.touched.asset_type_id &&
                            formik.errors.asset_type_id
                          }
                        />
                      </div>
                      <div>
                        <FloatingLabelInput
                          label="Company Name"
                          type="text"
                          id="asset_value"
                          name="asset_value"
                          value={formik.values.asset_value}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.asset_value &&
                            formik.errors.asset_value
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-[20px] pb-5  border-b-2">
                      <button
                        type="submit"
                        className="w-full font-semibold transition-all ease-in hover:bg-primary hover:text-white flex items-center gap-3 justify-center py-4 border-black border-[1px]"
                      >
                        <FiPlusCircle className="font-semibold text-[20px]" />{" "}
                        Add Another Assets
                      </button>
                    </div>
                  </form>
                  <div className="flex justify-between py-5">
                    <div>
                      <button
                        onClick={() => navigate("/dashboard")}
                        className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft /> Back
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => navigate("/dashboard")}
                        className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2"
                      >
                        Finish{" "}
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="max-lg:hidden bg-no-repeat ">
                    <div className="fixed top-[100px] w-[500px] right-[6%]">
                      <img src="/assets/images/8.png" alt="mascot" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AssetsComp;
